export const convertEvoPointsHistory = (data, statusCode) => {
    const items = data.data.map(({ balance_after, campaign, created_at, points, type, coupon, coupon_type, order_id }) => {
        return {
            type,
            points,
            coupon: coupon !== null && coupon !== void 0 ? coupon : "",
            event: campaign,
            date: created_at,
            balance: balance_after,
            order_id: order_id ? Number(order_id) : null,
            coupon_type: coupon_type,
        };
    });
    return {
        items,
        total: data.meta.total || 0,
        statusCode: statusCode || 200,
    };
};
//# sourceMappingURL=convertEvoPointsHistory.js.map